import { useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import NavData from "../data/Navdata";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="hamburger-nav">
            <button className="hamburger-btn" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
                {isOpen ? <RiCloseLine /> : <RiMenu3Line />}
            </button>
            {isOpen && (
                <>
                    <div className="hamburger-overlay" onClick={() => setIsOpen(false)} />
                    <ul className="hamburger-menu">
                        {NavData.map(i => (
                            <li key={i.id}>
                                <a href={i.link} onClick={() => setIsOpen(false)} {...(i.link.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}>{i.title}</a>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </nav>
    );
};

export default Navbar;
